import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { StarIcon } from "@/assets"
import { numberSpaceFixer } from "@/helpers/numberSpaceFixer"
import { ROUTES } from "@/helpers/routes"
import { Button } from "@/ui/Button"
import { Container } from "@/ui/Container"
import styles from "./CommissionCard.module.scss"
import type { ICommissionCard } from "./types"

export const CommissionCard: FC<ICommissionCard> = ({
  stars,
  starsToUsdRate,
  isLoading,
  isError
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleWithdraw = () => navigate(ROUTES.WALLET_WITHDRAW)

  const renderStars = () => {
    if (isLoading) {
      return <span className={styles.CommissionCard_skeleton} />
    }
    if (isError || stars === undefined) {
      return "—"
    }
    return numberSpaceFixer(stars, 0)
  }

  const renderUsdt = () => {
    if (isLoading) {
      return <span className={styles.CommissionCard_skeleton} />
    }
    if (isError || stars === undefined || !starsToUsdRate) {
      return t("referrals.commissions.usdtFallback")
    }
    const amount = Math.round(stars * starsToUsdRate)
    return t("referrals.commissions.usdtEquivalent", { amount })
  }

  return (
    <div className={styles.CommissionCard}>
      <div className={styles.CommissionCard_title}>
        {t("referrals.commissions.title")}
      </div>

      <Container
        className={styles.CommissionCard_plate}
        triangleTopPosLeft="10%"
        triangleBottomPosLeft="80%"
        revertBottomLeftTriangle
      >
        <div className={styles.CommissionCard_amountRow}>
          <StarIcon className={styles.CommissionCard_starIcon} />
          <span className={styles.CommissionCard_amountValue}>
            {renderStars()}
          </span>
        </div>
        <div className={styles.CommissionCard_usdtEquivalent}>
          {renderUsdt()}
        </div>
      </Container>

      <div className={styles.CommissionCard_divider} />

      <div className={styles.CommissionCard_description}>
        {t("referrals.commissions.description")}
      </div>

      <Button onClick={handleWithdraw}>
        {t("referrals.commissions.withdraw")}
      </Button>
    </div>
  )
}
